import { logMessage } from 'utils/sentryUtils';

import * as BundleCountSVGs from './BundleCountSVGs';

const svgs = {
    2: BundleCountSVGs.X2,
    3: BundleCountSVGs.X3,
    4: BundleCountSVGs.X4,
    5: BundleCountSVGs.X5,
    6: BundleCountSVGs.X6,
    7: BundleCountSVGs.X7,
};

/**
 * @param {2|3|4|5|6|7} count - The number of items in a bundle
 * @returns
 */
function BundleCount({ className, count, width = 40, ...restProps }) {
    if (!count) {
        return null;
    }

    const Component = svgs[count];

    if (!Component) {
        logMessage('Bundle count SVG missing', { count, level: 'warning' });
    }

    return (
        <div className={className} {...restProps}>
            {Component && (
                <div aria-hidden="true">
                    <Component width={width} />
                </div>
            )}
            <div className="sr-only">Bundle of {count}.</div>
        </div>
    );
}

export default BundleCount;
